import { DangerousHtml } from '~components/DangerousHtml';
import { SubHeadline, Text, Title } from '~components/Typography';

import { usePromoEventNeuronsModalDescription } from '../../hooks/usePromoEventNeuronsModalDescription';

export const PromoEventDescription = () => {
	const { description, title, subtitle } =
		usePromoEventNeuronsModalDescription();

	return (
		<>
			<Title size="M" align="center">
				<DangerousHtml>{title}</DangerousHtml>
			</Title>
			<Text size="L" align="center">
				<DangerousHtml>{subtitle}</DangerousHtml>
			</Text>
			<SubHeadline size="M">
				<DangerousHtml>{description}</DangerousHtml>
			</SubHeadline>
		</>
	);
};
